(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mc-shared"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mc-carousel')) {
    customElements.define(
      'mc-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.dots = this.querySelector('[data-dots]');
          if (!this.track) return;
          this.slides = Array.from(this.track.children);
          this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index() - 1));
          this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index() + 1));
          if (this.dots) {
            this.dots.innerHTML = this.slides.map(() => '<span></span>').join('');
          }
          this.track.addEventListener('scroll', () => this.sync(), { passive: true });
          window.addEventListener('resize', () => this.sync());
          this.sync();
        }
        step() {
          if (this.slides.length < 2) return this.track.clientWidth;
          return this.slides[1].offsetLeft - this.slides[0].offsetLeft;
        }
        index() {
          return Math.round(this.track.scrollLeft / this.step());
        }
        go(i) {
          const count = this.slides.length;
          const target = ((i % count) + count) % count;
          this.track.scrollTo({ left: target * this.step(), behavior: 'smooth' });
        }
        sync() {
          if (!this.dots) return;
          const current = Math.min(this.index(), this.slides.length - 1);
          Array.from(this.dots.children).forEach((dot, i) => {
            const distance = Math.abs(i - current);
            dot.toggleAttribute('data-far', distance > 2);
            if (distance === 1 || distance === 2) dot.dataset.near = String(distance);
            else delete dot.dataset.near;
            if (distance === 0) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
